<script lang="ts" setup>
import { ref } from 'vue'

import EventStatusIncidentsOnField from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/Pitch/EventStatusIncidentsOnField/EventStatusIncidentsOnField.vue'
import PitchBlockedIncidentOverlay from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidents/PitchParticipantWithIncidents/PitchBlockedIncidentOverlay.vue'
import PitchParticipantIncidents from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidents/PitchParticipantWithIncidents/PitchParticipantIncidents.vue'

// state
const eventStatusIncidentsOnFieldVisible = ref(false)
</script>

<template>
  <div class="relative">
    <PitchBlockedIncidentOverlay
      v-if="!eventStatusIncidentsOnFieldVisible"
      withText
    />
    <EventStatusIncidentsOnField
      @visible="eventStatusIncidentsOnFieldVisible = $event"
    />
    <PitchParticipantIncidents class="h-full" />
  </div>
</template>
